import { render, staticRenderFns } from "./cookiePrivadidad.vue?vue&type=template&id=42c3e126&scoped=true"
import script from "./cookiePrivadidad.vue?vue&type=script&lang=js"
export * from "./cookiePrivadidad.vue?vue&type=script&lang=js"
import style0 from "./cookiePrivadidad.vue?vue&type=style&index=0&id=42c3e126&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3e126",
  null
  
)

export default component.exports